// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/photoshop.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapGrapgicDesign {
    width: 100%;
    height: 691px;
    margin: 0 auto;
    padding: 0 3%;
    /* background-color: brown; */
    display: flex;
    justify-content: center;

    column-gap: 87px;
    flex-wrap: nowrap;
    overflow: hidden;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 100px 21%;
    background-size: 77px;

}

.LogoGraphic {
    margin-top: 100px;
    width: 673px;
}

.LogoGraphic p {
    padding-left: 21px;
    padding-top: 21px;
}

.slide_G {
    width: -moz-fit-content;
    width: fit-content;
}

@media screen and (max-width: 1723px) {
    .wrapGrapgicDesign {

        background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 41px 31%;
        background-size: 57px;
        height: 635px !important;
    }
}

@media screen and (max-width: 1555px) {
    .wrapGrapgicDesign {
        background: none;
        height: 433px;
    }
}

@media screen and (max-width: 1367px) {
    .wrapGrapgicDesign {
        margin-top: 77px;
        height: 475px !important;
    }

    .LogoGraphic {
        margin-top: 27px;
        width: 453px;
    }

    .LogoGraphic p {
        font-size: 15px;
    }

    .LogoGraphic img {
        height: 95px;
    }
}

@media screen and (max-width: 915px) {
    .wrapGrapgicDesign {
        height: 747px !important;
        justify-content: flex-start;
        flex-direction: column
    }
}

@media screen and (max-width: 455px) {
    .wrapGrapgicDesign {
        margin-top: 37px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/GraphicDes/GraphicDes.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;;IAEvB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,uEAA8D;IAC9D,qBAAqB;;AAEzB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI;;QAEI,sEAA6D;QAC7D,qBAAqB;QACrB,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,2BAA2B;QAC3B;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".wrapGrapgicDesign {\n    width: 100%;\n    height: 691px;\n    margin: 0 auto;\n    padding: 0 3%;\n    /* background-color: brown; */\n    display: flex;\n    justify-content: center;\n\n    column-gap: 87px;\n    flex-wrap: nowrap;\n    overflow: hidden;\n    background: url(\"../../img/photoshop.gif\") no-repeat 100px 21%;\n    background-size: 77px;\n\n}\n\n.LogoGraphic {\n    margin-top: 100px;\n    width: 673px;\n}\n\n.LogoGraphic p {\n    padding-left: 21px;\n    padding-top: 21px;\n}\n\n.slide_G {\n    width: fit-content;\n}\n\n@media screen and (max-width: 1723px) {\n    .wrapGrapgicDesign {\n\n        background: url(\"../../img/photoshop.gif\") no-repeat 41px 31%;\n        background-size: 57px;\n        height: 635px !important;\n    }\n}\n\n@media screen and (max-width: 1555px) {\n    .wrapGrapgicDesign {\n        background: none;\n        height: 433px;\n    }\n}\n\n@media screen and (max-width: 1367px) {\n    .wrapGrapgicDesign {\n        margin-top: 77px;\n        height: 475px !important;\n    }\n\n    .LogoGraphic {\n        margin-top: 27px;\n        width: 453px;\n    }\n\n    .LogoGraphic p {\n        font-size: 15px;\n    }\n\n    .LogoGraphic img {\n        height: 95px;\n    }\n}\n\n@media screen and (max-width: 915px) {\n    .wrapGrapgicDesign {\n        height: 747px !important;\n        justify-content: flex-start;\n        flex-direction: column\n    }\n}\n\n@media screen and (max-width: 455px) {\n    .wrapGrapgicDesign {\n        margin-top: 37px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
